module.exports = __webpack_public_path__ + "static/media/Helvetica-Light-01.1c51c835.svg";